import React from "react";
import {Box, Button, Grid, Input, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import Switch from "react-switch";

const useStyles = makeStyles(() => ({
    labelCaption: (props: any) => ({
        '&.MuiTypography-root': {
            fontSize: props.fontSize ? `${props.fontSize}px` : `14px`,
            fontWeight: props.isBold ? `bold` : `normal`,
            fontFamily: `revert`
        }
    }),
    radioBtnsGroupWithLabelWrapper: (props: any) => ({
        columnGap: "12px",
        '& > .MuiTypography-root': {
            fontSize: props.fontSize ? `${props.fontSize}px` : `14px`,
        }
    }),
    radioBtn: (props: any) => ({
        margin: `0`,
        columnGap: "4px",
        '&.MuiFormControlLabel-root': {
            margin: `0`,
        },
        '& > .MuiTypography-root': {
            fontSize: props.fontSize ? `${props.fontSize}px` : `14px`,
        }
    }),
    inputStyles: (props: any) => ({
        border: props.readonly ? "none" : "1px solid #888888",
        borderRadius: `5px`,
        width: `100%`,
        '&.MuiInput-root': {
            padding: `5px!important`,
            '& > input': {
                padding: 0,
                fontSize: props.fontSize ? `${props.fontSize}px` : `14px`,
                direction: props.direction === `rtl` ? `rtl` : `ltr`,
            },
        },
        "&.requiredField": {
            borderLeft: `4px solid #E5870E`,
            borderRadius: `0 5px 5px 0`,
        },
        "&.notValid": {
            borderLeftColor: `red`,
        },

    })
}))


interface Props {
    labelGridSizeNumber?: number;
    textareaGridSizeNumber?: number;
    valueForTextarea?: string;
    onChangeTextarea?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onChange?: (checked: boolean, name: string) => void;
    labelCaption?: string | null;
    labelAlign?: `start` | `end` | `center`;
    fontSize?: string;
    isBold?: boolean;
    numberOfRows?: number;
    isChecked?: boolean;
    isShowFromAccountBtn?: boolean;
    fieldName?: string;
    checkboxName?: string;
    readonly?: boolean;
    direction?: string;
    onCopyFromAccount?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    maxLength?: number;
    hideTextArea?: boolean;
    isNotValid?: boolean;
    isRequired?: boolean;
}

export const TextAreaWithSwitchControlAndLabel: React.FC<Props> = ({
                                                                      labelGridSizeNumber,
                                                                      textareaGridSizeNumber,
                                                                      valueForTextarea,
                                                                      onChangeTextarea,
                                                                      labelCaption,
                                                                      labelAlign,
                                                                      fontSize,
                                                                      isBold,
                                                                      numberOfRows,
                                                                      isChecked,
                                                                      isShowFromAccountBtn,
                                                                      onChange,
                                                                      fieldName,
                                                                      checkboxName,
                                                                      readonly,
                                                                      direction,
                                                                      onCopyFromAccount,
                                                                      maxLength,
                                                                      hideTextArea,
                                                                      isNotValid,
                                                                      isRequired
                                                                  }) => {
    const properties = {
        fontSize: fontSize ? fontSize : `14`,
        isBold: isBold ? isBold : '400',
        readonly: readonly,
        direction: direction,
    }
    const classes = useStyles(properties);

    const onChangeSwitch = (value: boolean) => {
        if(onChange){
            onChange(value, checkboxName ? checkboxName : '');
        }
    }
    return (
        <>
            <Grid item {...(labelGridSizeNumber ? {xs: labelGridSizeNumber} : {xs: true})}>
                <Typography className={classes.labelCaption} textTransform={`capitalize`}
                            textAlign={labelAlign ? labelAlign : 'start'}>
                    {labelCaption}
                </Typography>
            </Grid>
            <Grid item {...(textareaGridSizeNumber ? {xs: textareaGridSizeNumber} : {xs: true})}>
                <Box sx={{display: `flex`}}
                     justifyContent={fieldName === 'homePageUrl' ? "flex-end" : "space-between"}
                     mb={hideTextArea || (fieldName === 'homePageUrl' && readonly) || (fieldName === 'homePageUrl' && isShowFromAccountBtn) ? `0` : `10px`}
                >
                    {
                        onChange &&
                        /*
                                                <FormControlLabel
                                                    className={classes.checkboxWithLabelWrapper}
                                                    sx={{margin: `0`, fontSize: fontSize ? `${fontSize}px` : `14px`}}
                                                    control={
                                                        <Checkbox
                                                            name={checkboxName ? checkboxName : ''}
                                                            disableRipple disableTouchRipple
                                                            inputProps={{'aria-label': 'controlled'}}
                                                            size={'small'}
                                                            sx={{
                                                                padding: `0`,
                                                                marginRight: `5px`
                                                            }}
                                                            checked={isChecked ? isChecked : false}
                                                            disabled={readonly ? readonly : false}
                                                            onChange={onChangeCheckbox}
                                                        />

                                                    }
                                                    label={isChecked ? `Show` : `Don't Show`}
                                                />
                        */
                        <Box
                            sx={{
                                display: "flex",
                                columnGap: "8px",
                                alignItems: "center"
                            }}
                        >
                            <Switch
                                onChange={onChangeSwitch}
                                checked={isChecked ? isChecked : false}
                                className="react-switch"
                                height={20}
                                width={40}
                                handleDiameter={16}
                                onColor="#2A70BA"
                                onHandleColor="#ffffff"
                                disabled={readonly ? readonly : false}
                            />
                            <Typography fontSize={fontSize ? `${fontSize}px` : `14px`}>{isChecked ? `Show` : `Don't Show`}</Typography>
                        </Box>


                        // <RadioGroup
                        //     row
                        //     value={isChecked ? "1" : "0"}
                        //     onChange={onChange}
                        //     className={classes.radioBtnsGroupWithLabelWrapper}
                        // >
                        //     <FormControlLabel
                        //         value="1"
                        //         control={<Radio size="small"
                        //                         disableRipple disableTouchRipple
                        //                         name={checkboxName ? checkboxName : ''}
                        //                         sx={{
                        //                             padding: `0`,
                        //                         }}
                        //                         disabled={readonly ? readonly : false}
                        //                         inputProps={{'aria-label': 'controlled'}}
                        //         />}
                        //         label="Show"
                        //         className={classes.radioBtn}
                        //     />
                        //     <FormControlLabel
                        //         value="0"
                        //         control={<Radio size="small"
                        //                         disableRipple disableTouchRipple
                        //                         name={checkboxName ? checkboxName : ''}
                        //                         sx={{
                        //                             padding: `0`,
                        //                         }}
                        //                         disabled={readonly ? readonly : false}
                        //                         inputProps={{'aria-label': 'controlled'}}
                        //         />}
                        //         label="Don't Show"
                        //         className={classes.radioBtn}
                        //     />
                        // </RadioGroup>

                    }
                    {
                        ((!isShowFromAccountBtn && isChecked && !readonly) || (!isShowFromAccountBtn && fieldName === 'homePageUrl' && !readonly)) &&
                        <Button
                            name={fieldName ? fieldName : ''}
                            disableTouchRipple
                            disabled={readonly ? readonly : false}
                            onClick={onCopyFromAccount}
                        >
                            <Typography sx={{fontSize: `12px`, fontWeight: `bold`, color: `#E5870E`}}
                                        textTransform={`capitalize`}>
                                Copy From Account
                            </Typography>
                        </Button>
                    }

                </Box>
                {
                    !hideTextArea &&
                    <Box sx={{display: `flex`}}>
                        {
                            Boolean(numberOfRows)
                                ? <textarea
                                    name={fieldName ? fieldName : ''}
                                    rows={Boolean(numberOfRows) ? numberOfRows : 3}
                                    style={{
                                        resize: "none",
                                        border: "1px solid #888888",
                                        backgroundColor: `white`,
                                        // backgroundColor: readonly ? `rgba(0, 0, 0, 0.2)` : `white`,
                                        borderRadius: `5px`,
                                        padding: `5px`,
                                        width: `100%`,
                                        fontSize: fontSize ? `${fontSize}px` : `14px`,
                                        direction: direction === `rtl` ? `rtl` : `ltr`
                                    }}
                                    value={valueForTextarea}
                                    onChange={onChangeTextarea}
                                    maxLength={maxLength ? maxLength : 1000}
                                    {...(readonly ? {readOnly: readonly} : {})}
                                />
                                : <Input
                                    disableUnderline
                                    name={fieldName ? fieldName : ''}
                                    className={`${classes.inputStyles} ${isRequired && !readonly ? `requiredField` : ''} ${isNotValid ? 'notValid' : ''}`}
                                    value={valueForTextarea}
                                    onChange={onChangeTextarea}
                                    {...(readonly ? {readOnly: readonly} : {})}
                                />

                        }
                    </Box>
                }
            </Grid>
        </>
    )
}